import { IsNotEmpty, IsOptional, IsString } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateClassStatusDto {
  @ApiProperty({ type: 'string', description: 'Code du statut de classe', example: 'ACTIVE' })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({ type: 'string', description: 'Nom du statut de classe', example: 'Active' })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
